export default __webpack_public_path__ + "static/media/example4.39ffa2b4.svg";